export { HtmlTagNameDocumentHighlightsProvider } from './HtmlTagNameDocumentHighlightsProvider';
export { LiquidBlockTagDocumentHighlightsProvider } from './LiquidBlockTagDocumentHighlightsProvider';
